export class MenuItemModel {
    constructor(identity, name, link,) {
        this.identity = identity;
        this.name = name;
        this.link = link;

    }
}
